












import { createComponent, computed } from "@vue/composition-api";
import BaseNumericTag from "@web-components/components/BaseNumericTag.vue";

interface BaseDrinkInfoProps {
  value: number | string;
  title: string;
  description: string;
}

export default createComponent({
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  components: {
    BaseNumericTag
  },
  setup(props: Readonly<BaseDrinkInfoProps>) {
    const imageUrl = computed(() => {
      return (
        "https://drinkaware-web.azureedge.net/tools/tools/" +
        props.title.charAt(0).toUpperCase() +
        props.title.slice(1) +
        ".svg"
      );
    });

    return {
      imageUrl
    };
  }
});
